import { apiClient } from "./apiClient";

import type {
  TonUsdtInvoice,
  TonUsdtInvoiceCreate,
  TonUsdtInvoicePage,
} from "@/types/tonUsdtPayment";

export const tonUsdtPaymentsApi = {
  async createInvoice(data: TonUsdtInvoiceCreate): Promise<TonUsdtInvoice> {
    const response = await apiClient.post<TonUsdtInvoice>("/v1/payments/ton-usdt/invoices", data);
    return response.data;
  },

  async getInvoice(invoiceId: string): Promise<TonUsdtInvoice> {
    const response = await apiClient.get<TonUsdtInvoice>(
      `/v1/payments/ton-usdt/invoices/${invoiceId}`
    );
    return response.data;
  },

  async listInvoices({ limit, offset }: { limit: number; offset: number }): Promise<TonUsdtInvoicePage> {
    const response = await apiClient.get<TonUsdtInvoicePage>("/v1/payments/ton-usdt/invoices", {
      params: { limit, offset },
    });
    return response.data;
  },

  async cancelInvoice(invoiceId: string): Promise<TonUsdtInvoice> {
    const response = await apiClient.post<TonUsdtInvoice>(
      `/v1/payments/ton-usdt/invoices/${invoiceId}/cancel`
    );
    return response.data;
  },
};
